module.exports = __webpack_public_path__ + "img/jbl-speaker.66807511.png";